(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Variant selector functionality
document.addEventListener('DOMContentLoaded', function() {
  // Variant selection handler
  document.querySelectorAll('.custom-variant-selector').forEach(function(select) {
    select.addEventListener('change', function(e) {
      const selectedOption = this.options[this.selectedIndex];
      const productId = this.dataset.productId;
      const imageId = this.dataset.imageId;
      const priceMainId = this.dataset.priceMain;
      const priceCompareId = this.dataset.priceCompare;
      const addToCartId = this.dataset.addToCart;
      
      // Update image
      const imageSrc = selectedOption.dataset.image;
      if (imageId && imageSrc) {
        const imageElement = document.getElementById(imageId);
        if (imageElement) {
          imageElement.src = imageSrc;
        }
      }
      
      // Update price
      const price = selectedOption.dataset.price;
      const comparePrice = selectedOption.dataset.comparePrice;
      
      if (priceMainId && price) {
        const priceElement = document.getElementById(priceMainId);
        if (priceElement) {
          priceElement.textContent = price;
        }
      }
      
      // Update compare price
      if (priceCompareId) {
        const compareElement = document.getElementById(priceCompareId);
        if (compareElement) {
          if (comparePrice && comparePrice !== '0' && comparePrice !== '{{ 0 | money }}') {
            compareElement.textContent = comparePrice;
            compareElement.style.display = 'inline';
          } else {
            compareElement.style.display = 'none';
          }
        }
      }
      
      // Update add to cart button variant ID
      const variantId = selectedOption.value;
      const addToCartBtn = document.getElementById(addToCartId);
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;
        
        // Update button state based on availability
        const isAvailable = selectedOption.dataset.available === 'true';
        if (!isAvailable) {
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('custom-product-card__sold-out');
          addToCartBtn.querySelector('.custom-add-to-cart-text').textContent = 'Sold Out';
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('custom-product-card__sold-out');
          addToCartBtn.querySelector('.custom-add-to-cart-text').textContent = 'Add To Cart';
        }
      }
    });
  });
  
  // Add to Cart functionality
  document.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productId = this.dataset.productId;
      const variantId = this.dataset.variantId;
      
      // Check if variant is available
      if (this.disabled) return;
      
      // Add to cart logic
      console.log('Adding to cart:', { productId, variantId });
      
      // Example: Using Shopify AJAX Cart API
      // fetch('/cart/add.js', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     id: variantId,
      //     quantity: 1
      //   })
      // })
      // .then(response => response.json())
      // .then(data => {
      //   console.log('Added to cart:', data);
      // })
      // .catch(error => {
      //   console.error('Error adding to cart:', error);
      // });
      
      // Visual feedback
      const originalText = this.querySelector('.custom-add-to-cart-text').textContent;
      const icon = this.querySelector('.custom-add-to-cart-icon');
      this.querySelector('.custom-add-to-cart-text').textContent = 'Adding...';
      if (icon) icon.style.display = 'none';
      
      setTimeout(() => {
        this.querySelector('.custom-add-to-cart-text').textContent = 'Added ✓';
        if (icon) icon.style.display = 'inline';
        setTimeout(() => {
          this.querySelector('.custom-add-to-cart-text').textContent = originalText;
        }, 1500);
      }, 800);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
